import {useLocation} from "react-router-dom";
import {useLayoutEffect} from "react";

const ScrollToTopHelper = () => {
	const { pathname } = useLocation();

	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return null;
}

export default ScrollToTopHelper;
